import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler'
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

import {
	setModoTela, initForm
} from './oportunidadeActions';
import consts from '../consts';

class OPORTUNIDADEForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'>
					<ContentCard style={{ backgroundColor: '#63c8c3' }}>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>
									<Field
										name='nome'
										component={LabelAndInput}
										label='Nome: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									 
									<Field
										name='descricao'
										component={LabelAndTextarea}
										label='Descrição: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />

									<Grid cols='12 12 12 12' style={{ padding: 8, marginBottom: 24, }}>
										<div class='btn-group btn-group-toggle' data-toggle='buttons'>
											<label class={!this.props.formularioValues.finalizado ? 'btn btn-primary' : 'btn btn-secondary'} 
												style={{ width: 150 }}
												onClick={() => {
													this.props.initForm({
														...this.props.formularioValues,
														finalizado: false
													});
												}} >
												<input type='radio' name='options' id={`option_aberto`} autocomplete='off' checked={this.props.formularioValues.finalizado} /> Aberto
											</label>
											<label class={this.props.formularioValues.finalizado ? 'btn btn-danger' : 'btn btn-secondary'} 
												style={{ width: 150 }}
												onClick={() => {
													this.props.initForm({
														...this.props.formularioValues,
														finalizado: true
													});
												}} >
												<input type='radio' name='options' id={`option_finalizado`} autocomplete='off' checked={!this.props.formularioValues.finalizado} /> Finalizado
											</label>
										</div>
									</Grid>
									
									<Field
										name='data_realizacao'
										component={LabelAndInput}
										label='Data / Hora / Dias Realização: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='local_realizacao'
										component={LabelAndInput}
										label='Local de Realização: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='link_remoto_realizacao'
										component={LabelAndInput}
										label='Link Remoto de Realização: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='link_inscricao'
										component={LabelAndInput}
										label='Link de Inscrição: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='outra_inscricao'
										component={LabelAndInput}
										label='Outra Forma de Inscrição: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='contato'
										component={LabelAndInput}
										label='Contato: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Grid cols='12 12 12 12'
										style={{
											marginBottom: 12
										}}>

										<p>Imagem:</p>

										{(this.props.formularioValues.fotos || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img 
														style={{
															maxWidth: 150,
															width: 'auto',
															maxHeight: 150,
															height: 'auto',
															marginBottom: 12,
															backgroundColor: '#ffffff',
															padding: 8
														}}
														src={arquivo.arquivo_base64 ? arquivo.arquivo_base64 : `${consts.URL}/${arquivo.arquivo}`}>
													</img>
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-primary'
														style={{ width: '48%' }}
														disabled={arquivo.arquivo_base64 ? true : false}
														onClick={() => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>
													<button
														type='button'
														class='btn btn-flat btn-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																fotos: this.props.formularioValues.fotos.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										{!(this.props.formularioValues.fotos || []).length &&										
										<ClipboardImageHandler
											id='fotos'
											label='Use Ctrl+V para colar ou arraste e solte fotos aqui.'
											msgErro='Selecione apenas (.PNG, .JPG e .JPEG)'
											types={[
												'image/png',
												'image/jpg',
												'image/jpeg'
											]}
											onChange={result => {

												let lista = (this.props.formularioValues.fotos || []).map(item => item);
												lista.push({
													arquivo_base64: result
												});
												this.props.initForm({
													...this.props.formularioValues,
													fotos: lista
												});
											}} />}
									</Grid>

									{/*<Grid cols='12 12 12 12'
										style={{
											marginBottom: 12
										}}>

										<p>Anexos:</p>

										{(this.props.formularioValues.anexos || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={pdfAdicionado} style={{ height: 30 }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-primary'
														style={{ width: '48%' }}
														disabled={arquivo.arquivo_base64 ? true : false}
														onClick={() => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>
													<button
														type='button'
														class='btn btn-flat btn-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																anexos: this.props.formularioValues.anexos.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										
										<ClipboardImageHandler
											id='anexos'
											label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
											msgErro='Selecione apenas (.PDF)'
											types={[
												'application/pdf'
											]}
											onChange={result => {

												let lista = (this.props.formularioValues.anexos || []).map(item => item);
												lista.push({
													arquivo_base64: result
												});
												this.props.initForm({
													...this.props.formularioValues,
													anexos: lista
												});
											}} />
										</Grid>*/}

								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									<Grid cols='4 4 4 4'>
										<Button
											text='Voltar'
											type={'success'}
											icon={'fa fa-chevron-left'}
											event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
									</Grid>
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

OPORTUNIDADEForm = reduxForm({form: 'oportunidadeForm', destroyOnUnmount: false})(OPORTUNIDADEForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('oportunidadeForm')(state),
	registro: state.oportunidade.registro,
	lista: state.oportunidade.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(OPORTUNIDADEForm);
